// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Apply',
    back: 'Back to messages',
    cancel: 'Cancel',
    comment: 'Comment',
    commented_on_image: 'commented on the image',
    comments: 'Comments',
    delete: 'Delete',
    delete_comment: 'Delete this comment?',
    deleted_image: 'Image has been deleted',
    download: 'Download picture',
    edit: 'Edit',
    no_comment: 'No comments to display',
    write_comment: 'Write your comment',
};
